import { adapter } from '@seek/tealium-adapter';
import { Link } from 'braid-design-system';
import type { ChangeEvent, ComponentProps } from 'react';

type Origin = 'global-header' | 'global-footer';

const tealium = adapter();

const getPageTrackingData = () => {
  if (typeof window !== 'undefined') {
    return window.currentPageTrackingData;
  }
  return {};
};

export const consumerTrackingFunction =
  (origin: Origin) => (event: ChangeEvent<HTMLInputElement>) => {
    const currentPageTrackingData = getPageTrackingData();
    const eventName: string =
      event.currentTarget.getAttribute('data-analytics') || 'uncaught-event';

    tealium.link(eventName, {
      actionOrigin: origin,
      ...currentPageTrackingData,
    });
  };

export const linkRenderer =
  (origin: Origin) => (props: ComponentProps<typeof Link>) =>
    (
      <Link
        {...props}
        data-analytics-origin={origin}
        onClick={(event) => {
          // We will run our tracking function before continuing
          // to propagate other onClick events (if any).
          consumerTrackingFunction(origin);

          // Call onClick if it's set.
          if (props.onClick) {
            props.onClick(event);
          }
        }}
      />
    );
